<template>
    <div>
        <main class="layoutContent">
                <!-- Encabezado contenido principal -->
                <header class="page-header">
                    <div class="container pt-2">
                        <div class="row align-items-center justify-content-between">
                            <div class="col-auto pt-1">
                                <h1 class="page-header--title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                        <path
                                            d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                                        <path
                                            d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                    </svg>
                                    Solicitud Verano
                                </h1>
                                <p class="page-header--subtitle">
                                    Plan de vacaciones de verano
                                </p>
                            </div>
                            <div class="col-12 col-xl-auto mt-4">
                                <div class="text-right">
                                    <div class="text-white">Solicitud <span class="ml-2 p-2 page-header--title">{{ solicitud }}</span></div>
                                    <p class="page-header--subtitle">Fecha<span class="ml-2 p-2 font-weight-bold ">{{ fechasol }}</span></p>
                                </div>

                            </div>
                        </div>
                    </div>
                </header>
                <!-- Fin encabezado contenido principal -->

                <!-- Cuerpo contenido principal -->
                <div class="container content-body">
                    <div class="row">
                        <!-- Bloque Personas-->
                        <div class="col-xl-4 mb-2">
                            <!-- Card Datos solicitante -->
                            <div class="card mb-2">
                                <div class="card-header">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="bi bi-box" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg>
                                    Datos del solicitante
                                </div>
                                <div class="card-body">
                                    <div class="form-row">
                                        <div class="form-group col-12">
                                            <label>Dirección</label>
                                            <input class="form-control" type="text" placeholder="Dirección"
                                                v-model="EMP.dir"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <input class="form-control" id="empAddressCp" type="text"
                                                placeholder="Cod.Postal"
                                                v-model="EMP.cpo"/>
                                        </div>
                                        <div class="form-group col">
                                            <input class="form-control" id="empAddressPob" type="text"
                                                placeholder="Población"
                                                v-model="EMP.pob"/>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <input class="form-control" id="empAddressPro" type="text"
                                                placeholder="Provincia"
                                                v-model="EMP.pro"/>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col">
                                            <label for="telTrabajo">Tel. Trabajo</label>
                                            <input class="form-control" id="telTrabajo" type="text"
                                                v-model="EMP.tfnot"/>
                                        </div>
                                        <div class="form-group col">
                                            <label for="telParticular">Particular</label><input
                                                class="form-control" id="telParticular" type="text"
                                                v-model="EMP.tfnop"/>

                                        </div>
                                        <div class="form-group col">
                                            <label for="telMovil">Móvil</label><input class="form-control"
                                                id="telMovil" type="text"
                                                v-model="EMP.tfnom"/>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <label for="email">Email</label>
                                            <input class="form-control" id="empEmail" type="text"
                                                v-model="EMP.email"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Fin Card Datos solicitante -->
                        </div>

                        <!-- Bloque Establecimientos y Observaciones -->
                        <div class="col-xl-8 mb-2">
                            <!-- Card Datos solicitante -->
                            <div class="card mb-2">
                                <div class="card-header d-flex flex-column flex-sm-row align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="bi bi-box" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg>
                                    <div class="ml-1"> Asistentes</div>
                                    <div class="icons-actions ml-auto">
                                        <b-button variant="dark" size="sm" class="mt-1 mr-2" @click="cerrar">
                                            <b-icon icon="x-circle" variant="light" aria-hidden="true"></b-icon> Cancelar
                                        </b-button>
                                        <b-button variant="success" size="sm" class="mt-1 mr-2" @click="grabar">
                                            <b-icon icon="check-circle" variant="light" aria-hidden="true"></b-icon> GRABAR
                                        </b-button>

                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="box mb-0">
                                        <div class="box-content p-1 ">

                                            <!-- Solicitante -->
                                            <div class="form-row">
                                                <div class="form-group col-5">
                                                    <label for="nombreSolicitante">Solicitante/Acompañantes</label>
                                                    <input class="form-control col" disabled id="nombreSolicitante" type="text"
                                                        placeholder="Nombre Asistente" v-model="EMP.name"/>
                                                </div>
                                                <div class="form-group col-2">
                                                    <label for="aNacimiento">Año Nacim.</label>
                                                    <b-form-input class="form-control" disabled type="text" v-model="EMP.anac"/>
                                                </div>
                                                <div class="form-group col-2">
                                                    <label for="grupo">Grupo</label>
                                                    <b-form-select disabled :options="grupo" size="sm" v-model="tpe"></b-form-select>
                                                </div>
                                                <div class="form-group col-2">
                                                    <label for="matricula">Matrícula</label>
                                                    <b-form-input class="form-control" disabled type="text" v-model="EMP.id"/>
                                                </div>
                                                <div class="form-group col-1 mt-4">
                                                    <div class="justify-content-end">
                                                        <button class="btn btn-outline-success" type="button"
                                                            data-toggle="tooltip" data-placement="top" title=""
                                                            data-original-title="Añadir asistente"
                                                            @click="nuevo">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                height="24" fill="currentColor"
                                                                class="bi bi-person-plus" viewBox="0 0 16 16">
                                                                <path
                                                                    d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                                                <path fill-rule="evenodd"
                                                                    d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Acompañantes -->

                                            <!-- <div v-for="A in ASI" :key="A.id"> -->
                                            <!-- <div v-for="(value, key, index) in object"> -->
                                            <div v-for="(A, index) in ASI" :key="A.id">
                                                <div class="form-row">
                                                    <div class="form-group col-5">
                                                        <input class="form-control col" type="text" v-model="A.nom"/>
                                                    </div>
                                                    <div class="form-group col-2">
                                                        <input class="form-control" type="text" v-model="A.anac"/>
                                                        <!-- <input class="form-control" type="date" v-model="A.fhnac"/>                                                         -->
                                                    </div>
                                                    <div class="form-group col-2">
                                                        <b-form-select :options="grupo" size="sm" v-model="A.tp"></b-form-select>
                                                    </div>
                                                    <div class="form-group col-2 ">
                                                        <input class="form-control text-right" type="text"  v-model="A.nma"/>
                                                    </div>
                                                    <div class="form-group col-1">
                                                        <div class="justify-content-end">
                                                            <button class="btn btn-outline-danger" type="button"
                                                                data-toggle="tooltip" data-placement="top" title=""
                                                                data-original-title="Cancelar asistente"
                                                                @click="eliminar(index)">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" fill="currentColor"
                                                                    class="bi bi-x-square" viewBox="0 0 16 16">
                                                                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                                                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- {{ A }} -->
                                            </div>

                                            <!-- Recuento Personas  -->
                                            <div class="form-row">
                                                <div class="col-5 ml-1">
                                                <fieldset disabled>
                                                    <div class="form-row">
                                                        <div class="form-group col">
                                                            Personas <input class="form-control form-control-sm"
                                                                type="text" v-model="PAX.pax"/>
                                                        </div>
                                                        <div class="form-group col">
                                                            Adultos<input class="form-control form-control-sm"
                                                                type="text" v-model="PAX.adu"/>
                                                        </div>
                                                        <div class="form-group col">
                                                            Niños<input class="form-control form-control-sm"
                                                                type="text" v-model="PAX.nin"/>
                                                        </div>
                                                        <div class="form-group col">
                                                            Bebés<input class="form-control form-control-sm"
                                                                type="text" v-model="PAX.bbs"/>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- Fin Card Datos solicitante -->

                            <div class="card mb-1">
                                <div class="card-header d-flex align-items-center">Establecimientos
                                    <div class="icons-actions ml-auto">
                                        <b-button variant="info" size="sm" class="mt-1 mr-2" @click="precios">
                                            <b-icon icon="credit-card-fill" variant="light" aria-hidden="true"></b-icon> Precios
                                        </b-button>
                                    </div>
                                </div>
                                <div class="card-body pt-1 px-1">

                                    <!-- 1 -->
                                    <div class="accommodation mb-1">
                                        <div class="form-group row">
                                            <!-- <label for="establecimiento"
                                                class="col-2 col-form-label col-form-label-sm">Establecimiento</label> -->
                                            <div class="col-12">
                                                 <b-form-select v-model="SS.s1h" value-field="id" text-field="name"
                                                    @change="hotel_change(1)"
                                                    :options="itemsHot"
                                                    class="mb-1 form-control"
                                                ></b-form-select>
                                                <!-- <input type="text" disabled class="form-control" v-model="SS.s1hot"/> -->
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label col-form-label-sm">
                                                Periodo : Tipo
                                                <!-- <b-icon button class="mr-2 h6" variant="primary" icon="info-circle"
                                                    @click="turno_info(1)" v-show="SS.s1>''">
                                                </b-icon>                                                 -->
                                            </label>
                                            <!-- <div class="col-sm-4"> -->
                                            <div class="col-sm-6">
                                                <b-form-select v-model="SS.s1" value-field="id" text-field="per"
                                                    @change="turno_change(1)"
                                                    :options="itemsPer1"
                                                    class="mb-0 form-control"
                                                ></b-form-select>
                                                <!-- <input type="text" disabled class="form-control" v-model="SS.s1p" /> -->
                                            </div>
                                            <!-- <div class="form-inline col-sm-6"> -->
                                            <div class="form-inline col-sm-4">
                                                <div class="form-group mr-2">
                                                    <!-- <input type="text" disabled class="mr-2 form-control" v-model="SS.s1t"/> -->
                                                    {{ SS.s1tx }}
                                                    <!-- <input type="text" class="ml-2 col-sm-2 form-control" v-model="SS.s1h1"/> -->
                                                    <b-form-spinbutton class="ml-2" size="md" v-model="SS.s1h1" :disabled="!SS.s1h" min="1" max="3"></b-form-spinbutton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 2 -->
                                    <div class="accommodation mb-1">
                                        <div class="form-group row" disabled>
                                            <!-- <label for="establecimiento"
                                                class="col-sm-2 col-form-label col-form-label-sm">Establecimiento</label> -->
                                            <div class="col-sm-12">
                                                 <b-form-select v-model="SS.s2h" value-field="id" text-field="name" :disabled="!SS.s1h>''"
                                                    @change="hotel_change(2)"
                                                    :options="itemsHot"
                                                    class="mb-1 form-control"
                                                ></b-form-select>
                                                <!-- <input type="text" disabled class="form-control" v-model="SS.s1hot"/> -->
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label col-form-label-sm">
                                                Periodo : Tipo
                                                <!-- <b-btn disabled size="sm" class="ml-2"><b-icon icon="search" @click="buscar(1)"></b-icon></b-btn> -->
                                            </label>
                                            <!-- <div class="col-sm-4"> -->
                                            <div class="col-sm-6">
                                                <b-form-select v-model="SS.s2" value-field="id" text-field="per" :disabled="!SS.s2h>''"
                                                    @change="turno_change(2)"
                                                    :options="itemsPer2"
                                                    class="mb-0 form-control"
                                                ></b-form-select>
                                                <!-- <input type="text" disabled class="form-control" v-model="SS.s1p" /> -->
                                            </div>
                                            <!-- <div class="form-inline col-sm-6"> -->
                                            <div class="form-inline col-sm-4">
                                                <div class="form-group mr-2">
                                                    <!-- <input type="text" disabled class="mr-2 form-control" v-model="SS.s2t"/> -->
                                                    {{ SS.s2tx }}
                                                    <!-- input type="text" class="ml-2 col-sm-2 form-control" v-model="SS.s2h1" :disabled="!SS.s2h>''"/> -->
                                                    <b-form-spinbutton class="ml-2" size="md" v-model="SS.s2h1" :disabled="!SS.s2h" min="1" max="3"></b-form-spinbutton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 3 -->
                                    <div class="accommodation mb-1">
                                        <div class="form-group row">
                                            <!-- <label for="establecimiento"
                                                class="col-sm-2 col-form-label col-form-label-sm">Establecimiento</label> -->
                                            <div class="col-sm-12">
                                                 <b-form-select v-model="SS.s3h" value-field="id" text-field="name" :disabled="!SS.s2h>''"
                                                    @change="hotel_change(3)"
                                                    :options="itemsHot"
                                                    class="mb-1 form-control"
                                                ></b-form-select>
                                                <!-- <input type="text" disabled class="form-control" v-model="SS.s1hot"/> -->
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label col-form-label-sm">
                                                Periodo : Tipo
                                                <!-- <b-btn disabled size="sm" class="ml-2"><b-icon icon="search" @click="buscar(1)"></b-icon></b-btn> -->
                                            </label>
                                            <!-- <div class="col-sm-4"> -->
                                            <div class="col-sm-6">
                                                <b-form-select v-model="SS.s3" value-field="id" text-field="per" :disabled="!SS.s3h>''"
                                                    @change="turno_change(3)"
                                                    :options="itemsPer3"
                                                    class="mb-0 form-control"
                                                ></b-form-select>
                                            </div>
                                            <!-- <div class="form-inline col-sm-6"> -->
                                            <div class="form-inline col-sm-4">
                                                <div class="form-group mr-2">

                                                    <!-- <input type="text" disabled class="mr-2 form-control" v-model="SS.s3t"/> -->
                                                    {{ SS.s3tx }}
                                                    <!-- <input type="text" class="ml-2 col-sm-2 form-control" v-model="SS.s3h1" :disabled="!SS.s3h>''"/> -->
                                                     <b-form-spinbutton class="ml-2" size="md" v-model="SS.s3h1" :disabled="!SS.s3h" min="1" max="3"></b-form-spinbutton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">Observaciones</div>
                                <textarea class="mx-2 my-2 form-control" cols="30" rows="2" v-model="SS.sobs"/>
                                <div class="card-body">
                                    <p><small>
                                        Para acceso a Solicitudes ADJUDICADAS vea Menú Reservas.
                                        Desde ese apartado podrá ver e imprimir la
                                        documentación de la misma. En caso de NO ADJUDICADA o
                                        CANCELADA, deberá ir a VACANTES para ver los
                                        establecimientos y periodos disponibles.</small>
                                    </p>
                                </div>
                            </div>
                            <!-- {{ SS }} -->
                        </div>
                    </div>
                </div>
                <!-- Fin Cuerpo contenido principal -->
            </main>
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'solicitar_verano',

 /*  props: {
        datos: { type:Object, default: null},
  }, */

  data() {
    return {

        grupo:[
            {value:'0', text:'Especial'},
            {value:'1', text:'General'},
        ],
        tpe: 0,

        itemsHot:  [],
        itemsPer1: [],
        itemsPer2: [],
        itemsPer3: [],

        SS: {},

    }
  },

  created() {
  },

  mounted() {
      this.leemos();

      //this.SS=this.SOL;
  },

  computed: {
    ...mapState(['auth','fecha','EMP','ASI','SOL']),

    logueado() {
        return this.auth.logueado;
    },
    usuario() {
        return this.auth.user;
    },

    solicitud() {
        return this.SS.id>0 ? this.SS.id : 'NUEVA'
    },

    fechasol() {
        return !this.SS.fecha>'' ? this.fecha : this.SS.fecha;

    },

    //recuento
    PAX() {
        let Y=new Date().getFullYear();
        let p=1; let a=1; let n=0; let b=0; let aa=0; let nn=0;
        this.ASI.forEach(E => {
            if (Number(E.anac)>=Y-1) b++;
            else {
                p++;
                if (Number(E.anac)>=Y-12) n++; else a++;
                if (E.tp=='1') if (Number(E.anac)>=Y-12) nn++; else aa++;
            }
        });
        return {pax: p, adu: a, nin: n, bbs: b, adug: aa, ning: nn };
    }

  },

  methods: {
       ...mapMutations(['loading','alerta','modal']),
       ...mapActions(['exec']),

       async leemos() {
            //this.loading();

            var args={ token: this.auth.token, plan: 1 }
            let r=await this.exec({api:'hoteles_turnos', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                this.modal({tit:"Solicitud VERANO", msg:r.datos});
                r.datos=[];
                return;
            }
            //guardamos datos
            this.itemsHot=Object.values(r.datos[0]);

            //this.loading(false);

            let S=Object.assign({}, this.SOL);
            //alert(S.s1);
            this.SS=this.SOL;

            if (this.SS.s1>'0') this.hotel_change(1);
            if (this.SS.s2>'0') this.hotel_change(2);
            if (this.SS.s3>'0') this.hotel_change(3);

            //alert(S.s1);
            this.SS.s1=S.s1;
            this.SS.s2=S.s2;
            this.SS.s3=S.s3;

            if (this.SS.s1>'0') this.turno_change(1);
            if (this.SS.s2>'0') this.turno_change(2);
            if (this.SS.s3>'0') this.turno_change(3);

            this.SS.s1h1=S.s1h1;
            this.SS.s2h1=S.s2h1;
            this.SS.s3h1=S.s3h1;
        },

        hotel_change(v) {
            let h=this.SS['s' + v + 'h'];
            if (!h>'') return;
            let a=this.itemsHot.find(hotel => hotel.id==h);
            console.log('*hotel_change',v,h,a);

            let t=Object.values(a.turnos.datos[0]);

            if (v==1) this.itemsPer1=t;
            if (v==2) this.itemsPer2=t;
            if (v==3) this.itemsPer3=t;

            this.SS['s' + v]=t[0].id;
            this.SS['s' + v + 'tp']=t[0].tp;

            this.turno_change(v);
        },

        turno_change(v) {
            //alert(item);
            //let a=this.itemsPer.find(per => per.id==item);
            let P=(v==3 ? this.itemsPer3 : (v==2 ? this.itemsPer2 : this.itemsPer1));
            let x=this.SS['s' + v ];
            let a=P.find(per => per.id==Number(x));
            console.log('*turno_change',v,x,a);

            this.SS['s'+ v +'t']=a.tph;
            this.SS['s'+ v +'tx']=(a.tp==1?'Habit.':'Apart.');
            this.SS['s'+ v +'h1']=1;
            this.SS['s'+ v +'e']=a.fhe;
            this.SS['s'+ v +'s']=a.fhs;
            this.SS['s'+ v +'r']=a.reg;
            this.SS['s'+ v +'pp']=a.mpax;
            this.SS['s'+ v +'pa']=a.madu;
        },

        turno_info(v) {
            //alert(item);
            //let a=this.itemsPer.find(per => per.id==item);
            let P=(v==3 ? this.itemsPer3 : (v==2 ? this.itemsPer2 : this.itemsPer1));
            let x=this.SS['s' + v ];
            let a=P.find(per => per.id==Number(x));
            console.log('*turno_change',v,x,a);


            this.SS['s'+ v +'t']=a.tph;
            this.SS['s'+ v +'tx']=(a.tp==1?'Habit.':'Apart.');
            this.SS['s'+ v +'h1']=1;
            this.SS['s'+ v +'e']=a.fhe;
            this.SS['s'+ v +'s']=a.fhs;
            this.SS['s'+ v +'r']=a.reg;
            this.SS['s'+ v +'pp']=a.mpax;
            this.SS['s'+ v +'pa']=a.madu;

        },

        //solicitud
        async grabar() {
            console.log('**grabamos',this.EMP,this.ASI,this.SOL,this.SS);

            if (!this.validar()) return;

            let msg="Estas Seguro GUARDAR Solicitud ?";
            let r=await this.$root.$msgConf(msg,'SOLICITUD VERANO');
            if (!r) return;

            this.SS.adu=this.PAX.adu;
            this.SS.nin=this.PAX.nin;
            this.SS.bbs=this.PAX.bbs;
            this.SS.adug=this.PAX.adug; this.SS.ning=this.PAX.ning;

            var args={ token: this.auth.token, plan: 1, fnt:'set', EMP: this.EMP, SOL: this.SS, ASI: this.ASI  }
            r=await this.exec({api:'solicitud', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                this.modal({tit:"SOLICITUD VERANO", msg:r.datos});
                return;
            }
            //guardamos datos
            //this.itemsHot=Object.values(r.datos[0]);
            //this.loading(false);

            this.modal({tit:"SOLICITUD VERANO", msg:'Solicitud Guardada Correctamente'});
            this.$router.push('/');

        },

        validar() {
            let S=this.SS;
            let EM=this.EMP;
            let hh=0; let mn=0; let mx=0; let ma=0;
            let pp=this.PAX.pax; let pa=this.PAX.adu; let pn=this.PAX.nin;
            console.log('**validar',pp,pa,pn);

            let msg=''; let i=1;

            //empleado
            if (!EM.tfnot && !EM.tfnop && !EM.tfnom) msg+="<br>*Debe Introducir al menos un Teléfono de Contacto";
            if (!EM.pob && !EM.pro) msg+="<br>*Debe Introducir Población ó Provincia";
            if (!EM.email) msg+="<br>*Debe Introducir Correo Electrónico";

            //asistentes
            this.ASI.forEach(E => {
                if (!E.nom>'')  msg+="<br>*Falta Nombre del Asistente (" + i + ")";
                if (!E.anac>'') msg+="<br>*Falta Año Nacimiento del Asistente (" + i + ")";
            });

            if (!S.s1>'') msg+='<br>(1) Debes seleccionar un Establecimiento al menos';
            if (S.s1tp==1) { //si hotel
                hh=Number(S.s1h1);
                mn=Number(S.s1pp.charAt(0));
                mx=Number(S.s1pp.charAt(2));
                ma=Number(S.s1pa);
                //alert(p +'x'+hh +' '+mn+' '+mx);
                if (S.s1h=='232'||S.s1h=='235')
                    if (pa==ma && pp>pa) msg+='<br>(1) No disponible Habitaciones con 3 Adultos y un Niño';
                if (S.s1h=='19' && pn>0) msg+='<br>(1) No Permitido Niños en este Establecimiento';

                if (ma>0 && pa>(hh*ma)) msg+='<br>(1) Supera el numero de Adultos Máximo Permitidos (' + ma + ')';
                if (pp<(hh*mn)) msg+='<br>(1) Se requiere un minimo de personas por habitacion ('+mn+')';
                if (pp>(hh*mx)) msg+='<br>(1) Ha superado el maximo de personas por habitacion ('+mx+')';
            } else
            if (S.s1tp==2) { //apartamento
                hh=Number(S.s1h1);
                mx=Number(S.s1pp.charAt(0));
                if (pp>(hh*mx)) msg+='<br>(1) Ha superado el maximo de personas por habitacion ('+mx+')';
            }

            if (S.s2tp>0 && (S.s2==S.s1|| S.s2==S.s3))
                msg+='<br>(2) No se puede seleccionar el mismo Establecimiento y Turno';
            if (S.s2tp==1) { //si hotel
                hh=Number(S.s2h1);
                mn=Number(S.s2pp.charAt(0));
                mx=Number(S.s2pp.charAt(2));
                ma=Number(S.s2pa);
                if (S.s2h=='232'||S.s2h=='235')
                    if (pa==ma && pp>pa) msg+='<br>(2) No disponible Habitaciones con 3 Adultos y un Niño';
                if (S.s2h=='19' && pn>0) msg+='<br>(2) No Permitido Niños en este Establecimiento';

                if (ma>0 && pa>(hh*ma)) msg+='<br>(2) Supera el numero de Adultos Máximo Permitidos (' + ma + ')';
                if (pp<(hh*mn)) msg+='<br>(2) Se requiere un minimo de personas por habitacion ('+mn+')';
                if (pp>(hh*mx)) msg+='<br>(2) Ha superado el maximo de personas por habitacion ('+mx+')';
            } else
            if (S.s2tp==2) { //apartamento
                hh=Number(S.s2h1);
                mx=Number(S.s2pp.charAt(0));
                if (pp>(hh*mx)) msg+='<br>(2) Ha superado el maximo de personas por habitacion ('+mx+')';
            }

            if (S.s3tp>0 && (S.s3==S.s1||S.s3==S.s2)) msg+='<br>(3) No se puede seleccionar el mismo Establecimiento y Turno';
            if (S.s3tp==1) { //si hotel
                hh=Number(S.s3h1);
                mn=Number(S.s3pp.charAt(0));
                mx=Number(S.s3pp.charAt(2));
                ma=Number(S.s3pa);
                if (S.s3h=='232'||S.s3h=='235')
                    if (pa==ma && pp>pa) msg+='<br>(3) No disponible Habitaciones con 3 Adultos y un Niño';
                if (S.s3h=='19' && pn>0) msg+='<br>(3) No Permitido Niños en este Establecimiento';

                if (ma>0 && pa>(hh*ma)) msg+='<br>(3) Supera el numero de Adultos Máximo Permitidos (' + ma + ')';
                if (pp<(hh*mn)) msg+='<br>(3) Se requiere un minimo de personas por habitacion ('+mn+')';
                if (pp>(hh*mx)) msg+='<br>(3) Ha superado el maximo de personas por habitacion ('+mx+')';
            } else
            if (S.s3tp==2) { //apartamento
                hh=Number(S.s3h1);
                mx=Number(S.s3pp.charAt(0));
                if (pp>(hh*mx)) msg+='<br>(3) Ha superado el maximo de personas por habitacion ('+mx+')';
            }

            if (msg>'') {
                //this.$root.$msgBox(msg,'SOLICITUDES VERANO');
                this.modal({tit:"SOLICITUD VERANO", msg: msg});
                return false;
            }
            return true;
        },

        //periodos
        buscar(p=1) {
            alert('busqueda' + p);

            this.$bvModal.show("modal_hotelTurnos");
        },

        //asistentes
        nuevo() {
            this.ASI.push({nom:'',anac:'1960',tp: 1,nma:''});

        },
        async eliminar(index) {
             //alert('Anular');
            let msg="Estas Seguro Eliminar Asistente ?";
            let r=await this.$root.$msgConf(msg,'SOLICITUD VERANO');
            if (!r) return;

            this.ASI.splice(index,1);
        },

        cerrar() {
            let u=(!this.SS.id>'' ? '/' : '/verano');
            this.$router.push(u);
        },

        async precios() {
            if (!this.SS.s1>'') {
                this.modal({tit:"SOLICITUD VERANO", msg:"Debes seleccionar algún periodo, para el cálculo de Precios ..."});
                return;
            }

            if (!this.validar()) return;

            //this.$store.state.calculo=[];
            this.SS.adu=this.PAX.adu;
            this.SS.nin=this.PAX.nin;
            this.SS.bbs=this.PAX.bbs;
            this.SS.adug=this.PAX.adug; this.SS.ning=this.PAX.ning;

            let args={ token: this.auth.token, fnt:'precios', plan: 1, SOL: this.SS}
            let r=await this.exec({api:'solicitud', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                this.modal({tit:"SOLICITUD VERANO", msg:r.datos});
                return;
            }
            console.log("*precios",r.datos);

            this.$store.state.calculo=this.$util.object_array(r.datos[0]);

            this.$bvModal.show("modal_precios");
            //this.$router.push('/');
        },

   }
}
</script>